<script setup lang="ts">
import { onMounted, ref } from "vue";
import { DbIcon, DbInput } from "@db-ui/v-elements-enterprise/dist/components";
const input = ref("");
const showSuggestions = ref(false);
const filteredSuggestions = ref([]);
const autocompleteRef = ref("");
const emit = defineEmits(["onSelect", "update:modelValue"]);
const props = defineProps({
  modelValue: {
    default: "",
  },
  placeholder: {
    default: "",
  },
  disabled: {
    default: false,
  },
  hasError: {
    default: false,
  },
  name: {
    default: "",
    required: false,
  },
  label: {
    default: "",
    required: false,
  },
  options: {
    default: [],
    required: false,
  },
  icon: {
    default: "",
    required: false,
  },
  errorMessage: {
    default: "",
    required: false,
  },
});

const showClearIcon = ref(false);

const selectSuggestion = (suggestion: string) => {
  emit("update:modelValue", suggestion);
  showSuggestions.value = false;
  emit("onSelect", suggestion);
};
const transformString = (v: string) => v.toLowerCase().replace(" ", "");

const valueChange = (value: string) => {
  filteredSuggestions.value = props.options.filter((option) => {
    return transformString(option).includes(transformString(String(value)));
  });

  showClearIcon.value = value.length > 0;
  showSuggestions.value =
    filteredSuggestions.value.length > 0 && value.length > 2;
};

const closeSuggestionsIfClickedOutside = (event) => {
  if (autocompleteRef.value && !autocompleteRef.value.contains(event.target)) {
    showSuggestions.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", closeSuggestionsIfClickedOutside);
});
</script>
<template>
  <div class="w-full">
    <div class="relative">
      <db-input
        :label="label"
        :name="name"
        :disabled="disabled"
        :placeholder="placeholder"
        :value="modelValue"
        class="hydrated w-full"
        variant="semitransparent"
        @input="
          $emit('update:modelValue', $event.target.value);
          valueChange($event.target.value);
        "
        ref="input"
      ></db-input>
      <div
        class="db-icon cursor-pointer"
        v-if="showClearIcon"
        @click="
          $emit('update:modelValue', '');
          valueChange('');
          $emit('onSelect', '');
        "
        :db-icon="icon"
      >
        <div class="h-10 w-10 mt-2">
          <DbIcon :icon="icon" variant="24-outline"></DbIcon>
        </div>
      </div>
    </div>
    <div class="absolute z-10 w-[240px]" ref="autocompleteRef">
      <ul
        class="bg-white shadow-lg max-h-[400px] h-auto overflow-auto"
        v-if="showSuggestions"
      >
        <li
          class="py-2 px-2 hover:bg-gray-100"
          v-for="suggestion in filteredSuggestions"
          :key="suggestion"
          @click="selectSuggestion(suggestion)"
        >
          {{ suggestion }}
        </li>
      </ul>
    </div>
    <span v-if="errorMessage"
      ><p class="showError" v-html="errorMessage"></p
    ></span>
  </div>
</template>
<style scoped>
.default-input-class {
  margin-top: 0px;
}

.showError {
  color: #ec0016;
}
</style>
